/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Rows_EpicsInputs */

const en_tl_rows_epics = /** @type {(inputs: Tl_Rows_EpicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epics`)
};

const de_tl_rows_epics = /** @type {(inputs: Tl_Rows_EpicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epics`)
};

/**
* | output |
* | --- |
* | "Epics" |
*
* @param {Tl_Rows_EpicsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_rows_epics = /** @type {((inputs?: Tl_Rows_EpicsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Rows_EpicsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_rows_epics(inputs)
	return en_tl_rows_epics(inputs)
});